export const productCategories = [
  {
    value: 1,
    label: 'Gear & Apparel',
  },
  {
    value: 2,
    label: 'Tools & Subscriptions',
  },
  {
    value: 3,
    label: 'Coaching & Mentorship',
  },
  {
    value: 4,
    label: 'Memberships & Lifestyle Access',
  },
  {
    value: 5,
    label: 'Experiences & Events',
  },
  {
    value: 6,
    label: 'Personalized & Custom Gifts',
  },
  {
    value: 7,
    label: 'Recognition & Status Rewards',
  },
  {
    value: 8,
    label: 'Legacy Asset Rewards',
  },
]

export const productStatus = [
  {
    value: true,
    label: 'True',
  },
  {
    value: false,
    label: 'False',
  },
]

export const productSizes = [
  { value: 'XS', label: 'XS' },
  { value: 'S', label: 'S' },
  { value: 'M', label: 'M' },
  { value: 'L', label: 'L' },
  { value: 'XL', label: 'XL' },
  { value: 'XXL', label: 'XXL' },
  { value: 'XXXL', label: '3XL' },
]
